import { Editor, EditorProps } from '@progress/kendo-react-editor';
import React from 'react';

const KendoReactEditor = (props: EditorProps) => {
  return (
    <div className="kendo-react-editor">
      <link
        href="https://kendo.cdn.telerik.com/themes/7.0.1/material/material-main.css"
        rel="stylesheet"
        type="text/css"
      />
      <Editor
        tools={props.tools}
        defaultContent={props.defaultContent}
        onChange={props.onChange}
        onMount={props.onMount}
        resizable={props.resizable}
        contentStyle={props.contentStyle}
        style={props.style}
      />
    </div>
  );
};

export default KendoReactEditor;

export type {
  EditorChangeEvent,
  EditorMountEvent
} from '@progress/kendo-react-editor';

export { EditorTools } from '@progress/kendo-react-editor';
